import { createTheme } from '@material-ui/core/styles';

const colors = {
    white: '#fafafa !important',
}
export const theme = createTheme({
    palette: {
        //   primary: index
    },
    typography: {
        fontFamily: [
            'Roboto', 'sans-serif'
        ].join(','),
        subheading: {
            fontFamily: [
                'Roboto', 'sans-serif',
            ].join(',')
        },
        body2: {
            fontWeight: '600', // Change this to your desired font weight
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*::-webkit-scrollbar': {
                    width: '1em',
                    height: '0.45em'
                },
                '*::-webkit-scrollbar-track': {
                    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,.5)',
                    outline: '1px solid slategrey'
                },
            }
        },
        MuiDrawer: {

        },
        MuiFab: {
            secondary: {
                backgroundColor: '#00355f !important'
            },

        },
        MuiButton: {
            containedPrimary: {
                color: '#fafafa !important',
                backgroundColor: 'rgb(0,53,95) !important'
            },
        },

        MuiIcon: {
            root: {
                lineHeight: 'initial'
            }
        },

        MuiCheckbox: {
            colorPrimary: {
                color: '#1976d2 !important',
            },
            colorSecondary: {
                color: '#1976d2 !important',
            }
        },
        // MuiSwitch: {
        //     colorPrimary: {
        //         color: '#1976d2 !important',
        //     },
        //     colorSecondary: {
        //         color: '#1976d2 !important',
        //     }
        // },
        MuiAppBar: {
            colorPrimary: {
                color: colors.white,
                backgroundColor: '#212529 !important'
            },
            colorSecondary: {
                color: colors.white,
                backgroundColor: '#00355f !important'
            },
            colorDefault: {
                //color: '#fafafa !important',
                color: colors.white,
                backgroundColor: '#42a5f5 !important'
            }
        },
        MuiTypography: {
            body2: {
                fontSize: '0.8125rem',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 600,
                lineHeight: 1.43,
            },
            subtitle2: {
                color: '#6c757d !important',
            },
            colorPrimary: {
                color: '#00355f'
            },
            colorSecondary: {
                color: '#1f1d1d !important'
            },
            section: {
                color: '#ffffff !important'
            }

        },
        MuiFormControl: {
            root: {
                zIndex: 'auto'
            }
        },
        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiInputBase: {
            // root: {
            //     marginTop: '0px',
            //     color: 'grey'
            // }
        },
        MuiInputLabel: {
            formControl: {
                //color: 'grey',
                //  marginTop: '0px'
            }
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: 'black',
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize',
                minHeight: ''
            }
        },
        MuiIconButton: {
            root: {
                padding: '3px'
            },
            colorPrimary: {
                color: '#00355f !important'
            },
        },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        MuiPaper: {
            root: {
                borderRadius: '10px'
            }
        },
        MuiAccordion: {
            rounded: {
                borderRadius: '10px'
            }
        },
    }
});

export const laoacs_theme = createTheme({
    palette: {
        primary: {
            main: '#673ab7',
        },
        secondary: {
            main: '#673ab7',
        },
        error: {
            main: '#ab003c',
        },
        background: {
            default: '#fff',
        },
    },
    typography: {
        fontFamily: [
            'system-ui', 'sans-serif',
        ].join(','),
        subheading: {
            fontFamily: [
                'system-ui', 'sans-serif',
            ].join(',')
        },
        h6: {
            color: "inherit"
        },
        fontSize: 13,
        // fontWeightLight: 300,
        // fontWeightRegular: 400,
        // fontWeightMedium: 500,
    },
    overrides: {
        MuiContainer: {
            root: {
                maxWidth: {
                    xs: '100%',  // for screens smaller than 600px
                    sm: '600px',  // for screens larger than 600px
                    md: '960px',  // for screens larger than 960px
                    lg: '1280px',  // for screens larger than 1280px
                    xl: '1920px',  // for screens larger than 1920px
                },
            },
        },
        MuiCssBaseline: {
            '@global': {
                '*::-webkit-scrollbar': {
                    width: '0.3em',
                    height: '0.45em',
                },
                '*::-webkit-scrollbar-track': {
                    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'grey',
                    borderRadius: '10px',
                    outline: '1px solid grey'
                },
                '*::-webkit-scrollbar-thumb:hover': {
                    width: '1em',
                },
                '*::-webkit-scrollbar:hover': {
                    width: '1em',
                },
            }
        },
        // MuiTextField: {
        //     defaultProps: {
        //         size: 'small',
        //         margin: 'normal'
        //     },
        // },
        MuiButton: {
            text: {
                textTransform: 'none',
            },
            root: {
                textTransform: 'none'
            },
            defaultProps: {
                size: 'small',
            },
        },
        MuiFab: {
            defaultProps: {
                size: 'small',
            },
            root: {
                borderRadius: '8px',
                size: 'small',
                boxShadow: 'none',
                padding: '0px !important'
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small',
                padding: '0px !important'
            },
            colorPrimary: {
                backgroundColor: 'rgb(237, 231, 246)',
                borderRadius: '8px'
            }
        },
        MuiCheckbox: {
            defaultProps: {
                size: 'small',
            },
            root: {
                backgroundColor: 'white !important',
            }
        },
        MuiRadio: {
            defaultProps: {
                size: 'small',
            },
            root: {
                paddingTop: 8,
                backgroundColor: 'rgba(255, 255, 255,0)',// 50% transparent white
            }
        },
        MuiSwitch: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiSelect: {
            paddingTop: '3px !important',
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
        },
        MuiFilledInput: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiInputLabel: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiAutocomplete: {
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
        },
        // MuiFormControl: {
        //     defaultProps: {
        //         size: 'small',
        //         margin: 'normal'
        //     },
        // },
        MuiListItemIcon: {
            defaultProps: {
                size: 'small',
            },
            root: {
                minWidth: '30px !important'
            }

        },
        MuiListItemText: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiMenuItem: {
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
        },
        MuiCardContent: {
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
        },
        // MuiFab: {
        //     root: {
        //         boxShadow: '0px 0px 2px 0px '
        //     },
        //     sizeSmall: {
        //         width: '30px',
        //         height: '30px',
        //         minHeight: '30px',
        //         padding: '0px'
        //     },
        //     primary: {
        //         color: '#00355f !important',
        //         backgroundColor: '#fafafa !important',
        //     },
        //     secondary: {
        //         color: '#00355f !important',
        //         backgroundColor: '#fafafa !important'
        //     },

        // },
        // MuiButton: {
        //     text: {
        //         textTransform: 'none',
        //     },
        //     textPrimary: {
        //         color: '#00355f',
        //     },
        //     containedPrimary: {
        //         color: '#fafafa !important',
        //         backgroundColor: '#00355f !important'
        //     },
        //     root: {
        //         textTransform: 'none'
        //     }
        // },
        // MuiIcon: {
        //     root: {
        //         lineHeight: 'initial'
        //     }

        // },

        // MuiCheckbox: {
        //     colorPrimary: {
        //         color: '#00355f !important',
        //     },
        //     colorSecondary: {
        //         color: '#00355f !important',
        //     }
        // },
        // MuiListItemIcon: {
        //     root: {
        //         minWidth: '35px'
        //     }
        // },
        // MuiSwitch: {
        //     colorPrimary: {
        //         color: '#1976d2 !important',
        //     },
        //     colorSecondary: {
        //         color: '#1976d2 !important',
        //     }
        // },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: colors.white,
                color: '#212529'
            },
            colorSecondary: {
                backgroundColor: colors.white,
                color: '#00355f !important'
            },
            colorDefault: {
                //color: '#fafafa !important',
                backgroundColor: colors.white,
                color: '#42a5f5 !important'
            }
        },
        MuiTypography: {
            body2: {
                fontWeight: 400,
            },
            caption: {
                color: '#grey !important',
                fontSize: '0.875rem !important',
                fontWeight: '500 !important',
                //  color: '#697586 !important',
                // fontSize: '1rem !important',
            },
            h6: {
                color: '#808080 !important',
                fontSize: '18px !important',
                fontWeight: '500 !important',
            },
            subtitle1: {
                color: '#808080 !important',
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            subtitle2: {
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            displayBlock: {
                display: 'block',
                color: 'black',
            },
            colorPrimary: {
                color: '#3f51b5'
            },
        },
        // MuiTypography: {
        //     colorPrimary: {
        //         color: '#00355f'
        //     },
        //     colorSecondary: {
        //         color: '#1f1d1d !important'
        //     },
        //     section: {
        //         color: '#ffffff !important'
        //     }

        // },
        // MuiFormControl: {
        //     root: {
        //         zIndex: 'auto',
        //         marginTop: '5px',
        //         // margin: '2px'
        //     }
        // },
        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiFormGroup: {
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',  // for screens larger than 0px
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',  // for screens larger than 600px
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',  // for screens larger than 960px
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',  // for screens larger than 1280px
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',  // for screens larger than 1920px
                },
            },
        },
        MuiFormControlLabel: {
            label: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
            root: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiInputBase: {
            root: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
            input: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: 'black',
                        cursor: 'not-allowed',
                    },
                },
            },
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',  // for screens larger than 0px
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',  // for screens larger than 600px
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',  // for screens larger than 960px
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',  // for screens larger than 1280px
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',  // for screens larger than 1920px
                },
            }
        },
        // MuiInputLabel: {
        //     root: {
        //         marginBottom: {
        //             xs: theme.spacing(1),  // for screens smaller than 600px
        //             sm: theme.spacing(2),  // for screens larger than 600px
        //             md: theme.spacing(3),  // for screens larger than 960px
        //             lg: theme.spacing(4),  // for screens larger than 1280px
        //             xl: theme.spacing(5),  // for screens larger than 1920px
        //         },
        //     },
        //     formControl: {
        //         marginTop: '0px'
        //     }
        // },
        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTabs: {
            root: {
                minHeight: '0px'
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize',
            },
            textColorPrimary: {
                "&.Mui-selected": {
                    color: '#00355f !important',
                }
            },
        },
        MuiBox: {
            root: {
                padding: '0px'
            }
        },
        // MuiButtonBase: {
        //     // colorPrimary: {
        //     //     color: '#00355f !important',
        //     //     backgroundColor: '#fafafa !important',
        //     //     boxShadow: '0px 0px 2px 0px '
        //     // },
        //     // secondary: {
        //     //     color: '00355f !important',
        //     //     backgroundColor: '#fafafa !important',
        //     //     boxShadow: '0px 0px 2px 0px '
        //     // },
        //     // colorSecondary: {
        //     //     color: '00355f !important',
        //     //     backgroundColor: '#fafafa !important'
        //     // },
        // },
        // MuiIconButton: {
        //     root: {
        //         padding: '3px'
        //     }
        // },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiFormLabel: {
            root: {
                color: '#6c757d !important',
                fontWeight: '600'
            },
            asterisk: {
                color: 'red',
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        PrivateTabIndicator: {
            colorPrimary: {
                color: '#00355f',
                backgroundColor: '#00355f'
            }
        },
        MuiMobileStepper: {
            dotActive: {
                backgroundColor: '#00355f'
            }
        },
        MuiPaper: {
            root: {
                borderRadius: '5px'
            }
        },
        MuiListItem: {
            defaultProps: {
                size: 'small',
            },
            root: {
                '&:hover': {
                    backgroundColor: '#ede7f6 !important',  // Replace with your desired color
                    color: '#673ab7'
                },
                paddingTop: '5px !important',
                paddingBottom: '5px !important'
            },
        },
        MuiButtonBase: {
            defaultProps: {
                size: 'small',
                margin: 'normal',
                padding: '0px',

            },
        },


    }
});
